<template>
  <div style="padding: 0 10px">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>订单信息</span>
      </div>
      <el-descriptions :column="2">
        <el-descriptions-item label="发货编号">{{ detailInfo.deliveryTaskCode }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ detailInfo.deliveryStatus == 0 ? "待处理" : detailInfo.deliveryStatus == 1 ?
            "拣货中" : detailInfo.deliveryStatus == 2 ? "打标中" : detailInfo.deliveryStatus == 3 ? "打包中" :
              detailInfo.deliveryStatus == 4 ? "打包完成" : detailInfo.deliveryStatus == 5 ? "已发货" : ""
        }}
        </el-descriptions-item>
        <el-descriptions-item label="平台订单号" v-if="detailInfo.platformOrderNo">{{ detailInfo.platformOrderNo }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-card class="box-card" v-if="show('smallBag')">
      <div slot="header" class="clearfix">
        <span>发件人信息</span>
      </div>
      <el-descriptions :column="4">
        <el-descriptions-item label="姓名">{{ sendAddress.name }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ sendAddress.mobile }}</el-descriptions-item>
        <el-descriptions-item label="联系邮箱">{{ sendAddress.email }}</el-descriptions-item>
        <el-descriptions-item label="所属国家">{{ sendAddress.nation }}</el-descriptions-item>
        <el-descriptions-item label="省/州">{{ sendAddress.province }}</el-descriptions-item>
        <el-descriptions-item label="所属城市">{{ sendAddress.city }}</el-descriptions-item>
        <el-descriptions-item label="所属区域">{{ sendAddress.area }}</el-descriptions-item>
        <el-descriptions-item label="邮编">{{ sendAddress.postalCode }}</el-descriptions-item>
        <el-descriptions-item label="邮寄地址" :span="4">{{ sendAddress.address }}</el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>客户信息</span>
      </div>
      <el-descriptions :column="4">
        <el-descriptions-item label="姓名">{{ receiveAddress.name }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{getPhoneCode(receiveAddress.province)}}{{ receiveAddress.mobile }}</el-descriptions-item>
        <el-descriptions-item label="联系邮箱">{{ receiveAddress.email }}</el-descriptions-item>
        <el-descriptions-item label="所属国家">{{ receiveAddress.nation }}</el-descriptions-item>
        <el-descriptions-item label="省/州">{{ receiveAddress.province }}</el-descriptions-item>
        <el-descriptions-item label="所属城市">{{ receiveAddress.city }}</el-descriptions-item>
        <el-descriptions-item label="所属区域">{{ receiveAddress.area }}</el-descriptions-item>
        <el-descriptions-item label="邮编">{{ receiveAddress.postalCode }}</el-descriptions-item>
        <el-descriptions-item label="邮寄地址" :span="4">{{ receiveAddress.address }}</el-descriptions-item>
        <!-- <el-descriptions-item label="邮寄地址" :span="4">{{ receiveAddress.nation }}-{{ receiveAddress.province }}-{{
            receiveAddress.city
        }}-{{ receiveAddress.area }}</el-descriptions-item> -->
      </el-descriptions>
    </el-card>
    <el-card class="box-card" v-if="enAddress">
      <div slot="header" class="clearfix">
        <span>英文收货地址</span>
      </div>
      <el-descriptions :column="4">
        <el-descriptions-item label="姓名">{{ enAddress.name }}</el-descriptions-item>
        <el-descriptions-item label="公司名">{{ enAddress.companyName }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ enAddress.mobile }}</el-descriptions-item>
        <el-descriptions-item label="联系邮箱">{{ enAddress.email }}</el-descriptions-item>
        <el-descriptions-item label="所属国家">{{ enAddress.nation }}</el-descriptions-item>
        <el-descriptions-item label="省/州">{{ enAddress.province }}</el-descriptions-item>
        <el-descriptions-item label="所属城市">{{ enAddress.city }}</el-descriptions-item>
        <el-descriptions-item label="所属区域">{{ enAddress.area }}</el-descriptions-item>
        <el-descriptions-item label="邮编">{{ enAddress.postalCode }}</el-descriptions-item>
        <el-descriptions-item label="会社编号">{{ enAddress.clubCode }}</el-descriptions-item>
        <el-descriptions-item label="详细地址">{{ enAddress.address }}</el-descriptions-item>
        <!-- <el-descriptions-item label="姓名">{{ enAddress.name }}</el-descriptions-item>
        <el-descriptions-item label="省/州">{{ enAddress.province }}</el-descriptions-item>
        <el-descriptions-item label="所属城市">{{ enAddress.city }}</el-descriptions-item>
        <el-descriptions-item label="所属区域">{{ enAddress.area }}</el-descriptions-item>
        <el-descriptions-item label="详细地址">{{ enAddress.address }}</el-descriptions-item> -->
      </el-descriptions>
    </el-card>
    <el-card class="box-card" v-if="enClearAddress">
      <div slot="header" class="clearfix">
        <span>英文清关地址</span>
      </div>
      <el-descriptions :column="4">
        <el-descriptions-item label="姓名">{{ enClearAddress.name }}</el-descriptions-item>
        <el-descriptions-item label="公司名">{{ enClearAddress.companyName }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ enClearAddress.mobile }}</el-descriptions-item>
        <el-descriptions-item label="联系邮箱">{{ enClearAddress.email }}</el-descriptions-item>
        <el-descriptions-item label="所属国家">{{ enClearAddress.nation }}</el-descriptions-item>
        <el-descriptions-item label="省/州">{{ enClearAddress.province }}</el-descriptions-item>
        <el-descriptions-item label="所属城市">{{ enClearAddress.city }}</el-descriptions-item>
        <el-descriptions-item label="所属区域">{{ enClearAddress.area }}</el-descriptions-item>
        <el-descriptions-item label="邮编">{{ enClearAddress.postalCode }}</el-descriptions-item>
        <el-descriptions-item label="会社编号">{{ enClearAddress.clubCode }}</el-descriptions-item>
        <el-descriptions-item label="详细地址">{{ enClearAddress.address }}</el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>物流信息</span>
      </div>
      <el-descriptions :column="1" v-for="(item, indexLogistics) in detailInfo.logisticsDetailList"
        :key="indexLogistics">
        <el-descriptions-item label="物流渠道">{{
            detailInfo.wmsForwarder
        }}-{{
    detailInfo.wmsShippingType
}}</el-descriptions-item>
        <el-descriptions-item label="货运单号">{{ item.logisticsCode }}</el-descriptions-item>
        <el-descriptions-item label="货运重量">
          <div class="editBoxList">
            <div v-for="(deliveryBox, index) in item.deliveryBoxList" :key="index"
              style="display:flex;align-items: center;margin-bottom: 20px;">
              箱子{{ index + 1 }}
              <div v-if="!deliveryBox.showEdit" class="editDiv">
                <span>{{ deliveryBox.weight }} g </span>
                <i class="el-icon-edit" style="margin-left:10px;font-size: 20px;"
                  @click="editWeight(deliveryBox, index, indexLogistics)" v-if="detailInfo.deliveryStatus < 5"></i>
              </div>
              <div v-if="deliveryBox.showEdit" class="editDiv">
                <el-input maxlength='450' type="text" v-model="editWeightNum" style="width:100px"></el-input><span
                  style="margin-left:10px">
                  g</span>
                <i class="el-icon-circle-check" style="margin-left:10px;font-size: 20px;color: green;"
                  @click="editWeight_check(deliveryBox, index, indexLogistics)" v-if="detailInfo.deliveryStatus < 5"></i>
                <i class="el-icon-circle-close" style="margin-left:10px;font-size: 20px;color: red;"
                  @click="editWeight_close(deliveryBox, index, indexLogistics)" v-if="detailInfo.deliveryStatus < 5"></i>
              </div>
            </div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>附加项</span>
      </div>
      <WmsTable :columns="columnsAddition" :hasHeader="false" :scrollY="300" :is-pagination="false"
        :dataSource="detailInfo.deliveryTaskAdditionalDetailList">
        <div slot="image" slot-scope="{text}">
          <ImgPreviews :images="text.split(',')" width="60" height="60" v-if="text"/>
        </div>
      </WmsTable>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>申报信息</span>
      </div>
      <WmsTable :columns="columns" :hasHeader="false" :scrollY="300" :is-pagination="false"
        :dataSource="detailInfo.taskDetailList">
        <div slot="productImgAction" slot-scope="{ text, record, index }">
          <ImgView :src="text" width="60" height="60" />
        </div>
        <div class="productPriceInput" slot="productPrice" slot-scope="{ text, record, index }">
          <el-input placeholder="请输入内容" v-model="text" :disabled="true">
            <template slot="append">{{ record.currencyCode }}</template>
          </el-input>
        </div>
        <div slot="action" slot-scope="{ text, record, index }">
          <a @click="openRemark(record, index)">备注</a>
        </div>
      </WmsTable>
    </el-card>
    <el-dialog title="备注" :visible.sync="visible" width="30%">
      <el-input maxlength='450' type="textarea" :rows="4" placeholder="请输入内容" v-model="remark">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkBoxClose">取 消</el-button>
        <el-button type="primary" @click="remarkConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import ImgPreviews from "@/components/ImgPreviews";
import {
  skuRemark,
  editWeight
} from "@/apis/outStock";

export default {
  name: "shipInvoiceDetails", // 估计发货 -- 订单详情
  props: {
    shipInvoiceId: {
      type: String | Number,
    },
    prentType: {
      type: String
    }
  },
  components: {
    WmsTable,
    ImgView,
    ImgPreviews
  },
  activated() {
    if (!this.$route.params.info) {
      // this.$router.replace('/outOfStock_internationalShipment')
      return
    }
    var info = this.$route.params.info;
    info.logisticsDetailList &&
      info.logisticsDetailList.forEach((temp) => {
        temp.weight = 0;
        temp.deliveryBoxList &&
          temp.deliveryBoxList.forEach((boxItem) => {
            temp.weight += Number(boxItem.weight);
            boxItem.showEdit = false
          });
      });
    this.receiveAddress =''
    this.enAddress =''
    this.enClearAddress =''
    this.sendAddress =''
    info.deliveryTaskAddressList && info.deliveryTaskAddressList.forEach((item) => {
      item.addressType == 0 && (this.receiveAddress = item)
      item.addressType == 1 && (this.enAddress = item)
      item.addressType == 2 && (this.enClearAddress = item)
      item.addressType == 3 && (this.sendAddress = item)
    })
    this.detailInfo = info;
    this.showEdit = false
  },
  data() {
    return {
      // 0:收件人地址 1:英文收货地址 2:英文清关地址 3:发件人地址
      enAddress: '',//英文收货地址
      enClearAddress: '',//英文清关地址
      sendAddress: '',//发件人地址
      receiveAddress: '',//收件人地址
      detailInfo: {},
      dataSourceOne: [],
      columnsAddition: [
        { title: '附加项名称', key: 'additionName', dataIndex: 'additionName' },
        { title: '辅料名称', key: 'ingredientsName', dataIndex: 'ingredientsName' },
        {
          title: '辅料图片', key: 'image', dataIndex: 'image',
          scopedSlots: {
            customRender: "image",
          },
        },
        { title: '辅料SKU', key: 'ingredientsSku', dataIndex: 'ingredientsSku' },
        { title: '实际操作数量', key: 'operand', dataIndex: 'operand'},
      ],
      columns: [
        {
          title: "商品图片",
          key: "productImg",
          dataIndex: "productImg",
          width: 140,
          scopedSlots: {
            customRender: "productImgAction",
          },
        },
        { title: "SKU", key: "shopProductSku", dataIndex: "shopProductSku" },
        { title: "数量", key: "deliveryNums", dataIndex: "deliveryNums" },
        { title: "销售单价", key: "productPrice", dataIndex: "productPrice",
          scopedSlots: {
            customRender: "productPrice",
          },
        },
        // { title: "仓库", key: "org", dataIndex: "org" },
        { title: "可用库存", key: "checked", dataIndex: "checked" },
        { title: "备注", key: "remark", dataIndex: "remark" },
        {
          title: "操作", key: "action", scopedSlots: {
            customRender: "action",
          },
        },
      ],
      dataSourceTwo: [],
      visible: false,
      skuInfo: { remark: '' },
      showEdit: false,
      editWeightNum: 0,
      remark: ''
    };
  },
  methods: {
    getPhoneCode(province) {
      if (province === 'Hong Kong') {
        return '(+852)'
      }
      if (province === 'Taiwan China') {
        return '(+886)'
      }
      if (province === 'Macao') {
        return '(+853)'
      }
      return ''
    },
    show(type) {
      return type.includes(this.prentType)
    },
    openRemark(record, index) {
      this.visible = true
      this.skuInfo = record
      this.remark = record.remark
      this.remarkindex = index
    },
    // 关闭备注
    remarkBoxClose: function () {
      this.visible = false
      this.remark = ''
    },

    // 添加备注
    remarkConfirm: function () {
      let params = {
        deliveryTaskDetailId: this.skuInfo.deliveryTaskDetailId,
        remark: this.remark,
      };
      skuRemark(params).then(({ code }) => {
        if (code == 0) {
          this.$message.success("成功");
          let data = { ...this.detailInfo }
          data.taskDetailList[this.remarkindex].remark = this.remark
          this.visible = false
        }
      });
    },
    editWeight(item, index, indexLogistics) {
      // this.showEdit = true
      let data = { ...this.detailInfo }
      data.logisticsDetailList.forEach(item => {
        item.deliveryBoxList.forEach(item_son => {
          item_son.showEdit = false
        })
      })
      data.logisticsDetailList[indexLogistics].deliveryBoxList[index].showEdit = true
      this.detailInfo = data
      this.editWeightNum = item.weight
    },
    editWeight_check(item, index, indexLogistics) {
      let params = {
        deliveryBoxCode: item.deliveryBoxCode,
        weight: this.editWeightNum
      }
      editWeight(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("修改成功")
          let data = { ...this.detailInfo }
          data.logisticsDetailList[indexLogistics].deliveryBoxList[index].weight = this.editWeightNum
          data.logisticsDetailList[indexLogistics].deliveryBoxList[index].showEdit = false
          this.detailInfo = data
        }
      })
    },
    editWeight_close(item, index, indexLogistics) {
      let data = { ...this.detailInfo }
      data.logisticsDetailList[indexLogistics].deliveryBoxList[index].showEdit = false
      this.detailInfo = data
    },
    showLogisticsName(logisticsCompanyCode) {
      return {
        YD: '杭州义达',
        SKB: '杭州思凯比',
        TH: '广州天汇',
        OCS: 'OCS',
        other: '其他'
      }[logisticsCompanyCode]
    }
  }
};
</script>

<style scoped>
.box-card ::v-deep.el-card__header {
  background: #f8f8f8;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

.editBoxList {
  display: flex;
  flex-direction: column;
  /* flex-direction: row; */
}

.editDiv {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
</style>
<style>
.productPriceInput .el-input input{
  background-color: #fff !important;
  cursor: text !important;
}
</style>
